/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  HStack,
  Avatar,
  VStack,
  Text,
  Button,
  IconButton,
  Tooltip,
  Center,
  Divider,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  Menu,
  MenuItem,
  MenuButton,
  MenuList,
} from '@mybridge/ui';
import React, { useContext, useState } from 'react';
import {
  FolderIcon,
  TeamNewIcon,
  CalendarIcon,
  EventIcon,
  Search,
  FolderIcon2,
  VideoCallIcon,
  CallIcon,
  TeamMembersIcon,
  DiskIcon,
  TeamInvitesIcon,
  ExitFullScreenIcon,
  MemberIcon,
  AddPersonIcon,
  DownArrowIcon,
  DownArrowIcon2,
  LogoutIcon,
  ExitGroup,
  InfoFilledIcon,
  VideoCallIconFilled,
} from '@mybridge/icons';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { TeamsContext } from '../../context';
import { formatCommaSeparated } from 'v4/lib/commons';
import { useRouter } from 'next/router';
import {
  joinMeeting,
  generateMeetingId,
  scheduleMeetingWithUser,
  setMeetNow,
  setPendingMeetingMessage,
} from 'v4/store/actions/meeting.actions';
import { useDispatch, useSelector } from 'react-redux';
import Link from 'next/link';
import { isDesktop } from 'react-device-detect';
import { CloseIcon, InfoIcon } from '@chakra-ui/icons';
import { List, ListIcon, ListItem } from '@chakra-ui/react';
import { InfoLinedIcon } from '@mybridge/icons/CampaignIcon';
import styles from '../../../../components/header/status-dropdown/statusProfile.module.scss';
import OutgoingCall from 'v4/snippets/message/outgoing-call';
import { TeamLeaveModal } from '../../team-leave-modal';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
const TeamChatHeader = ({ teamDetails,onSendMessage,selectedChat, ...props }) => {
  const {
    invitationDisc,
    createTeamChatPosts
  } = useContext(TeamsContext);
  const router = useRouter();
  const { t } = useTranslator();
  const dispatch = useDispatch();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const { matrixClient, loggedInUser, teamsChats, callStatus,initiateMatrixCall, initiateCall } = useContext(MatrixContext);
  const { setChatTeamSlug, chatTeamSlug, isMember, isOrganizer, chatRoom, teamMembers, setChatRoom, leaveTeamDisc } = useContext(TeamsContext);


    const currentUserId = userProfileInfo?.id; // Assuming `userProfileInfo` has the current user's ID
    const organizerIds = teamDetails?.organizers?.map((org) => org.id) || [];
    // if (organizerIds.includes(currentUserId))return




  const [city, state, country] = teamDetails?.location?.split?.(', ') ?? [];
  const loc = formatCommaSeparated([city, state, country]);
  const [isCallModalOpen, setIsCallModalOpen] = useState(false);

  const handleScheduleMeeting = () => {
    dispatch(
      scheduleMeetingWithUser({
        users: _.map(teamMembers, 'user'),
        type: 'team',
      })
    );
    router.push(`/profile/calendar/schedule?team=${teamDetails?.id}`);
  };

  const handleSendMessageWrapper = (content) => {
    if (
      !teamDetails?.permission_new_post &&
      isMember &&
      isMember?.status === 'member' &&
      !isOrganizer
    ) {
      createTeamChatPosts({
        id: teamDetails?.id,
        message: content?.body,
        message_category: 'text',
      });
    } else {
      if (onSendMessage) {
        onSendMessage(content);
      }
    }
  };

  const handleStartTeamMeeting = async (onlySendLink) => {
    await dispatch(generateMeetingId()).then(async(res) => {
      if (res) {
        const meetingId = res?.payload?.meeting?.meeting_slug;
        const meetingLink = `${process.env.BASE_PUBLIC_URL}meet/${meetingId}`;

        const plainTextMessage = `Let's meet\nPlease join using this link: ${meetingLink} \n Meeting ID: ${meetingId}`;
        const htmlMessage = `
          Let's meet<br/>
          Please join using this link: 
          <a href="${meetingLink}">${meetingLink}</a><br/>
          Meeting ID: ${meetingId}
        `;

        const content = {
          body: plainTextMessage, 
          type: 'org.matrix.custom.html', 
          formatted_body: htmlMessage,  
          msg_type: 'm.text',  
        };

        // if (onSendMessage) {
        //   await onSendMessage(content)
        //   // dispatch(
        //   //   joinMeeting({
        //   //     created_by: userProfileInfo,
        //   //     meetingId: meetingId,
        //   //     attendees: null,
        //   //     isWaiting: true,
        //   //   })
        //   // )
        // }
          // dispatch(setPendingMeetingMessage({onSendMessage, content, onlySendLink}));
          dispatch(setPendingMeetingMessage({onSendMessage: handleSendMessageWrapper, content, onlySendLink}));
          dispatch(setMeetNow(true));
      }
    });
  };

  const listStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    justifyContent: 'flex-start',
    cursor: 'pointer',
    marginTop: "3px",
  };

  const listStyleHover = {
    "&:hover": {
      backgroundColor: "#3D5A8024",
    },
  }

  return (
    <Box mb={5} p={3} {...props}>
      <HStack justifyContent="space-between">
        <HStack gap={3}>
          <Avatar
            size="md"
            icon={<TeamNewIcon color="#9F9F9F" width="20" height="20" />}
            bg="#D9D9D9"
            src={
              teamDetails?.image_logo &&
              !teamDetails?.image_logo?.includes('logo-placeholder-image')
                ? teamDetails?.image_logo
                : null
            }
          />
          <VStack alignItems="stretch" flex="1" gap={1}>
            <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0 }}>
              <Text fontSize="14px" fontWeight="700" color="black">
                {teamDetails?.name}
              </Text>
              <Popover>
                {({ onClose }) => (
                  <>
                    <PopoverTrigger>
                      <Button
                        variant="none"
                        padding="0px"
                        leftIcon={<DownArrowIcon2 width="15px" height="15px" />}
                      />
                    </PopoverTrigger>
                    <PopoverContent style={{ borderRadius: "12px", width: "251px" }}>
                      <PopoverArrow />
                      <PopoverBody borderRadius="12px" paddingRight={0} paddingLeft={0} boxShadow="0px 4px 10px 0px #00000026"
                      >
                        <List spacing={3}>
                          <ListItem style={listStyle} sx={listStyleHover}>
                            <Button
                              onClick={() => {
                                handleStartTeamMeeting();
                                onClose(); 
                              }}
                              variant="none"
                              leftIcon={<EventIcon width="18px" height="18px" color="#5B5B5B" />}
                            >
                              {t('myCalendar.meetNow') || "Meet Now"}
                            </Button>
                          </ListItem>
                          <ListItem style={listStyle} sx={listStyleHover}>
                            <Button
                              onClick={() => {
                                handleScheduleMeeting();
                                onClose(); 
                              }}
                              variant="none"
                              leftIcon={<CalendarIcon width="18px" height="18px" color="#5B5B5B" />}
                            >
                              {t('common.scheduleMeeting') || "Schedule a Meeting"}
                            </Button>
                          </ListItem>
                         
                          {/* <ListItem style={listStyle} sx={listStyleHover}>
                            <Button
                              onClick={() => {
                                initiateCall(teamDetails?.matrix_chat_room_id, "audio")
                                setIsCallModalOpen(true);
                                onClose(); 
                              }}
                              variant="none"
                              leftIcon={<CallIcon width="18px" height="18px" color="#5B5B5B" />}
                            >
                              {t('teams.audioChat') || "Audio Chat"}
                            </Button>
                          </ListItem> */}
                          <Divider />
                          <ListItem style={listStyle} sx={listStyleHover}>
                            <Button
                              onClick={() => {
                                router.push(`/teams/${teamDetails?.slug}`);
                                onClose(); 
                              }}
                              variant="none"
                              leftIcon={<InfoIcon width="20px" height="20px" color="#5B5B5B" />}
                            >
                              {t('teams.teamInfo') || "Team Info"}
                            </Button>
                          </ListItem>
                          <ListItem style={listStyle} sx={listStyleHover}>
                            <Button
                              onClick={() => {
                                router.push(`teams/${teamDetails?.slug}/${organizerIds.includes(currentUserId)?'manage':'members'}`);
                                onClose(); 
                              }}
                              variant="none"
                              leftIcon={<MemberIcon width="18px" height="18px" color="#5B5B5B" />}
                            >
                              {t('myMessages.members') || "Members"}
                            </Button>
                          </ListItem>
                         {teamDetails?.organize_type==='team'&&( <ListItem style={listStyle} sx={listStyleHover}>
                            <Button
                              onClick={() => {
                                router.push(`/profile/disk/?team=${teamDetails?.id}`);
                                onClose(); 
                              }}
                              variant="none"
                              leftIcon={<FolderIcon2 width="18px" height="18px" color="#5B5B5B" />}
                            >
                              {t('teams.teamDisk') || "Team Disk"}
                            </Button>
                          </ListItem>)}
                          <ListItem style={listStyle} sx={listStyleHover}>
                            {(!teamDetails?.permission_invite_members||organizerIds.includes(currentUserId))&&(<Button
                              onClick={(e) => {
                                invitationDisc?.onOpen?.();
                                onClose(); 
                              }}
                              variant="none"
                              leftIcon={<AddPersonIcon width="18px" height="18px" color="#5B5B5B" />}
                            >
                              {t('teams.inviteFriends') || "Invite Friends"}
                            </Button>)}
                          </ListItem>
                          <Divider />
                          <ListItem style={listStyle} sx={listStyleHover}>
                            <Button
                              onClick={() => {
                                leaveTeamDisc.onOpen();
                                onClose(); 
                              }}
                              variant="none"
                              leftIcon={<ExitGroup width="18px" height="18px" color="#5B5B5B" />}
                            >
                              {teamDetails?.organize_type==='community' ? t('teamCommunity.exitCommunity') : t('teams.exitTeam') || "Exit Team"}
                            </Button>
                          </ListItem>
                        </List>
                      </PopoverBody>
                    </PopoverContent>
                  </>
                )}
              </Popover>
              {teamDetails?.slug && (
                <Button 
                  onClick={() => router.push(`/teams/${teamDetails?.slug}`)} 
                  size="sm" 
                  height="26px" 
                  width={teamDetails?.organize_type !== "community" ? "100px" : "120px"} 
                  variant="darkGrayButton" 
                  bg="#3D5A80" 
                  borderRadius="full" 
                  fontSize="12px"
                  marginRight={teamDetails?.organize_type !== "community" ? "3%" : "0"}
                >
                  {teamDetails?.organize_type !== "community" ? t('teams.teamInfo') || "Team Info" : t('teamCommunity.communityInfo') || "Team Community"}
                </Button>
              )}
            </Box>
            <Text fontSize={["10px","12px","12px","14px"]} fontWeight="400" color="brandGray.4">
              {isDesktop ? formatCommaSeparated(
                [teamDetails?.industry_name?.[0]?.name, loc],
                ' | '
              ) : teamDetails?.industry_name?.[0]?.name}
            </Text>
          </VStack>
        </HStack>
        <HStack gap={1}>
          {/* <Link href={`/teams/${teamDetails?.slug}`}>
            <Button size="sm" variant="darkGrayButton" borderRadius="full"
            marginRight={teamDetails?.organize_type !== "community" ? "3%" : "0"}
            >
              Team Info
            </Button>
          </Link> */}
          {isDesktop ? (
            <>
              {(
                <>
                  <Center height="30px">
                    <Divider />
                  </Center>
                 
                  <Tooltip label={t('common.scheduleMeeting') || "Schedule a Meeting"}>
                    <IconButton
                      variant="transparent"
                      borderRadius="full"
                      sx={{"&:hover": {
                        background: "#E3E3E3"
                      }}}
                      onClick={() => handleScheduleMeeting()}
                      icon={<CalendarIcon height="22px" width="22px" color="#3D5A80" />}
                    />
                  </Tooltip>
                  
                  <Tooltip label={t('myCalendar.meetNow') || "Meet Now"}>
                    <Box>
                      <Menu>
                      <MenuButton
                        as={IconButton}
                        icon={<EventIcon height="22px" width="22px" color="#3D5A80" />}
                        borderRadius="full"
                        variant="transparent"
                        isDisabled={
                          !(teamDetails?.permission_invite_members ||
                            organizerIds?.includes(userProfileInfo?.id))
                        }
                        sx={{
                          "&:hover": {
                            background: "#E3E3E3",
                          },
                        }}
                      />
                        <MenuList>
                          <MenuItem onClick={() => {
                            if(teamDetails?.permission_invite_members || organizerIds?.includes(userProfileInfo?.id)){
                              handleStartTeamMeeting();
                            }
                          }}>
                            Meet Now
                          </MenuItem>
                          <MenuItem onClick={() => {
                            if(teamDetails?.permission_invite_members || organizerIds?.includes(userProfileInfo?.id)){
                              handleStartTeamMeeting(true);
                            }
                          }}>
                            Send Meeting Link
                          </MenuItem>
                        </MenuList>
                      </Menu>
                    </Box>
                  </Tooltip>
                </>
              )}

              {teamDetails?.organize_type !== "community" &&
                <Tooltip label={t('teams.teamDisk') || "Team Disk"}>
                  <IconButton
                    icon={<FolderIcon2 height="22px" width="22px"  />}
                    variant="transparent"
                    borderRadius="full"
                    sx={{"&:hover": {
                      background: "#E3E3E3"
                    }}}
                    onClick={() => router.push(`/profile/disk/?team=${teamDetails?.id}`)}
                  />
                </Tooltip>
              }
            </>
          ) : <IconButton size="sm" variant="transparent" onClick={() => setChatRoom()} icon={<CloseIcon />} />}

          {/* <IconButton
            variant="transparent"
            // onClick={() => handleStartTeamMeeting()}
            icon={<Search />}
          /> */}




          
        </HStack>
        {/* {isCallModalOpen && callStatus!=='ended'&&<OutgoingCall setIsCallModalOpen={setIsCallModalOpen} selectedChat={selectedChat} callStatus={callStatus} callerComponent="teams" style={{zIndex:"999"}}/>} */}
        <TeamLeaveModal
          title={t('teams.leaveTeam') || "Leave Team"}
          onClose={() => leaveTeamDisc.onClose()} // Close modal when needed
        />
      </HStack>
    </Box>
  );
};

export default TeamChatHeader;
